import { useState } from "react";
import { Tabs, TabsProps, Flex, Tag, Text } from "@/base/components/index";
import { useSectionTabsStyles } from "./section-tabs.styles";
import { SectionTabsProps } from "../types/index";

export const SectionTabs = ({
  items,
  activeKey: controlledActiveKey,
  onChange,
  className,
}: SectionTabsProps) => {
  const { styles } = useSectionTabsStyles();
  const [internalActiveKey, setInternalActiveKey] = useState<string>(
    items[0]?.key || "",
  );

  const activeKey = controlledActiveKey ?? internalActiveKey;
  const handleChange = onChange ?? setInternalActiveKey;

  const tabsItems: TabsProps["items"] = items.map((item) => ({
    key: item.key,
    label: (
      <Flex justify="space-between" gap={8}>
        <Text>{item.label}</Text>
        {item.count !== undefined && item.count > 0 && (
          <Tag color="processing" bordered={false} closable={false}>
            {item.count}
          </Tag>
        )}
      </Flex>
    ),
    children: item.children,
  }));

  return (
    <Tabs
      items={tabsItems}
      activeKey={activeKey}
      onChange={handleChange}
      className={`${styles.tabs} ${className || ""}`}
    />
  );
};
